import type { Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import {
  getActiveTabType,
  getAnalyticsParamsSelector,
  getAvailableTabs,
  getIsAnalyticsParamsLoaded,
  getOffersByTypeSelector,
  getOffersHaveBeenLoadedByType,
  getOffersSelector,
  getPixels,
  getRequestForOrganizationDone,
} from '../selectors/offers';

import { useAppSelector } from './redux';

export const useOffers = () => useAppSelector(getOffersSelector);
export const useOffersByType = (type: Tab<VITRINS_OFFERS_TYPE>) => useAppSelector(getOffersByTypeSelector(type));
export const useAnalyticsParams = () => useAppSelector(getAnalyticsParamsSelector);
export const useIsAnalyticsParamsLoaded = () => useAppSelector(getIsAnalyticsParamsLoaded);
export const useActiveTabType = () => useAppSelector(getActiveTabType);
export const usePixels = () => useAppSelector(getPixels);
export const useAvailableTabs = () => useAppSelector(getAvailableTabs);
export const useOffersHaveBeenLoadedByType = (type: Tab<VITRINS_OFFERS_TYPE>) =>
  useAppSelector(getOffersHaveBeenLoadedByType(type));
export const useRequestForOrganizationDone = () => useAppSelector(getRequestForOrganizationDone);
